const focusable = () => ({
    focusables: null,
    query: `a, button`,

    rm( els, sel = '' ) {
        if ( !els ) return this;
        this.focusables = els.querySelectorAll(sel || this.query);
        [...this.focusables].forEach(
            el => el.setAttribute('tabindex', '-1')
        )
        return this
    },
    add( els, sel = '' ) {
        if ( !els ) return this;
        this.focusables = els.querySelectorAll(sel || this.query);
        [...this.focusables].forEach(
            el => el.removeAttribute('tabindex')
        )
        return this
    },
})

export const focusables = {
    methods: {
        focusables: focusable
    },
}